import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useIntakes } from '../../hooks/useIntakes';
import Button from '../../components/common/Button';
import Card from '../../components/common/Card';
import Table from '../../components/common/Table';
import Input from '../../components/common/Input';
import { PlusIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const IntakeList = () => {
  const { intakes, loading, error, deleteIntake } = useIntakes();
  const [searchTerm, setSearchTerm] = useState('');

  const filteredIntakes = intakes.filter(intake => {
    return intake.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
           (intake.description && intake.description.toLowerCase().includes(searchTerm.toLowerCase()));
  });

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this intake?')) {
      const result = await deleteIntake(id);
      if (result.success) {
        alert('Intake deleted successfully');
      } else {
        alert(result.error || 'Failed to delete intake');
      }
    }
  };

  const columns = [
    {
      header: 'Intake Name',
      accessor: (row) => row.name,
      cell: (value) => value || '-'
    },
    {
      header: 'Start Date',
      accessor: (row) => row.start_date,
      cell: (value) => value || '-'
    },
    {
      header: 'End Date',
      accessor: (row) => row.end_date,
      cell: (value) => value || '-'
    },
    {
      header: 'Description',
      accessor: (row) => row.description,
      cell: (value) => value || '-'
    },
    {
      header: 'Actions',
      accessor: (row) => row.id,
      cell: (value) => (
        <div className="flex space-x-2">
          <Link to={`/intakes/${value}/edit`}>
            <Button variant="outline" size="sm">Edit</Button>
          </Link>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => handleDelete(value)}
            className="text-red-600 hover:text-red-800"
          >
            Delete
          </Button>
        </div>
      )
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-xl font-bold text-gray-900">Intakes Management</h1>
        <Link to="/intakes/new">
          <Button>
            <PlusIcon className="h-5 w-5 mr-1" />
            Add Intake
          </Button>
        </Link>
      </div>
      
      <Card>
        <div className="mb-4">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
            </div>
            <Input
              type="text"
              placeholder="Search intakes..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10"
            />
          </div>
        </div>
        
        {loading ? (
          <div className="text-center py-8">Loading intakes...</div>
        ) : error ? (
          <div className="text-center py-8 text-red-500">Error: {error}</div>
        ) : (
          <Table 
            columns={columns} 
            data={filteredIntakes} 
            emptyMessage="No intakes found"
          />
        )}
      </Card>
    </div>
  );
};

export default IntakeList;